module.exports = __webpack_public_path__ + "img/sidenav.9b686561.png";